import { render, staticRenderFns } from "./InfluencerCategoryEdit.vue?vue&type=template&id=b7f87398"
import script from "./InfluencerCategoryEdit.vue?vue&type=script&lang=js"
export * from "./InfluencerCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports